export const REMOTE_MODULES = {
  facet: {
    module: 'Facet',
    scope: 'facet',
  },
  prism: {
    module: 'Prism',
    scope: 'prism',
  },
  quartz: {
    module: 'Quartz',
    scope: 'quartz',
  },
  gobletLegacy: {
    module: 'Goblet-legacy',
    scope: 'goblet-legacy',
  },
  goblet: {
    module: 'Goblet',
    scope: 'goblet',
  },
};
